import React from 'react'
import { FaEye } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'
import './permissions-control.less'

type CanReadControlProps = {
  onClick?: () => void
  canRead: boolean
  viewOnly?: boolean
}

const CanReadControl = ({ onClick, canRead, viewOnly }: CanReadControlProps) => {
  return (
    <div className={cn('control', 'permissions-control', { selected: canRead, viewOnly })} data-graph-type="control">
      <a className={cn('icon')} onClick={onClick} title="Reader">
        <FaEye aria-hidden />
        <span className="sr-only">Can Read</span>
      </a>
    </div>
  )
}

export default CanReadControl
